// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2cb8d76f","977":"3b15e6ce"}[chunkId] + ".chunk.js";
};